/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOCreateDisputeResponseDTO } from '../models/ApiResponseDTOCreateDisputeResponseDTO';
import type { ApiResponseDTODisputeTypesListResponseDTO } from '../models/ApiResponseDTODisputeTypesListResponseDTO';
import type { CreateDisputeRequestRecord } from '../models/CreateDisputeRequestRecord';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DisputesApiService {

    /**
     * Create a dispute
     * This endpoint will allow you to create a new dispute, which will be sent to Back Office
     * @param requestBody 
     * @returns ApiResponseDTOCreateDisputeResponseDTO OK
     * @throws ApiError
     */
    public static createDispute(
requestBody: CreateDisputeRequestRecord,
): CancelablePromise<ApiResponseDTOCreateDisputeResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/disputes',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Request the list of possible dispute types
     * Will request the updated list of possible dispute types from CBS
     * @returns ApiResponseDTODisputeTypesListResponseDTO OK
     * @throws ApiError
     */
    public static getTypesList(): CancelablePromise<ApiResponseDTODisputeTypesListResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/disputes/types',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

}
